<template>
  <el-dialog :title="$t('371')" v-if="visible" :visible.sync="visible" :close-on-click-modal="false" width="659px" append-to-body>
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="190px">
      <!-- 名 + 称谓 -->
      <el-form-item class="name name1" :label="$t('1048')" required>
        <el-form-item prop="call_type" class="call_type">
          <el-select v-model="dataForm.call_type" :placeholder="$t('1047')" @change="handlerChangeCallType">
            <el-option v-for="item in callTypeList.default" :key="item.code" :label="item.txt" :value="item.code" />
          </el-select>
        </el-form-item>
        <el-form-item prop="first_name" class="first_name">
          <el-input
            v-model="dataForm.first_name"
            :class="[
              !dataForm.first_name ? 'first_name' : '',
              !dataForm.call_type ? 'call_type' : '',
              'input-with-select'
            ]"
          />
        </el-form-item>
      </el-form-item>
      <!-- <el-form-item class="name" :label="$t('1048')" :prop="!dataForm.call_type ? 'call_type' : 'first_name'">
        <el-input
          v-model="dataForm.first_name"
          :class="[
            !dataForm.first_name ? 'first_name' : '',
            !dataForm.call_type ? 'call_type' : '',
            'input-with-select'
          ]"
        >
          <el-select
            v-model="dataForm.call_type"
            slot="prepend"
            :placeholder="$t('1047')"
            @change="handlerChangeCallType"
          >
            <el-option
              v-for="item in callTypeList.default"
              :key="item.code"
              :label="item.txt"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-input>
      </el-form-item> -->
      <!-- 姓 -->
      <el-form-item :label="$t('1049')" prop="last_name">
        <el-input v-model="dataForm.last_name"></el-input>
      </el-form-item>
      <!-- 英文名+称谓 -->
      <el-form-item class="name name1" :label="$t('name_en')">
        <el-form-item prop="call_type" class="call_type">
          <el-select v-model="dataForm.call_type_en" :placeholder="$t('1047')">
            <el-option v-for="item in callTypeList.en" :key="item.code" :label="item.txt" :value="item.code" />
          </el-select>
        </el-form-item>
        <el-form-item prop="first_name" class="first_name">
          <el-input
            v-model="dataForm.first_name_en"
            :class="[
              !dataForm.first_name ? 'first_name' : '',
              !dataForm.call_type ? 'call_type' : '',
              'input-with-select'
            ]"
          />
        </el-form-item>
      </el-form-item>
      <!-- 英文姓 -->
      <el-form-item :label="$t('1858')">
        <el-input v-model="dataForm.last_name_en"></el-input>
      </el-form-item>
      <el-form-item :label="$t('825')">
        <el-input v-model="dataForm.phone" disabled></el-input>
      </el-form-item>
      <el-form-item :label="$t('27')" prop="department_name">
        <el-popover v-model="popover" ref="orgPopover" placement="bottom-start" trigger="click">
          <dep-tree v-if="popover" @node-click="handleNodeClick"></dep-tree>
        </el-popover>
        <el-input v-model="dataForm.department_name" v-popover:orgPopover readonly :placeholder="$t('877')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('24')">
        <job-select v-model="dataForm.job_title_id" />
      </el-form-item>
      <el-form-item :label="$t('25')">
        <el-input v-model="dataForm.staff_code"></el-input>
      </el-form-item>
      <!-- 入职日期 -->
      <el-form-item :label="$t('28')" prop="hire_date">
        <el-date-picker
          type="date"
          v-model="dataForm.hire_date"
          value-format="yyyy-MM-dd"
          :placeholder="$t('878')"
          @change="onHireDate"
        ></el-date-picker>
      </el-form-item>
      <!-- 试用期(天) -->
      <el-form-item :label="$t('invite_7')">
        <el-input
          v-model.number="dataForm.probation_day"
          @input="dataForm.probation_day = String(dataForm.probation_day).replace(/[^\d]/g, '')"
          @blur="onProbationDay(dataForm.probation_day)"
          :placeholder="$t('90')"
          clearable
        />
      </el-form-item>
      <!-- 转正日期 -->
      <el-form-item>
        <template slot="label">
          <el-tooltip class="item" effect="dark" :content="$t('invite_8')" placement="top-start">
            <i class="el-icon-warning"></i>
          </el-tooltip>
          <span>{{ $t('30') }}</span>
        </template>
        <el-date-picker
          type="date"
          v-model="dataForm.formal_date"
          value-format="yyyy-MM-dd"
          :placeholder="$t('878')"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('34')" prop="salary_method">
        <el-select v-model="dataForm.salary_method" :placeholder="$t('221')">
          <el-option v-for="item in salaryList" :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('33')" prop="settlement_type">
        <el-select v-model="dataForm.settlement_type" :placeholder="$t('221')">
          <el-option v-for="item in settlemenList" :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <!-- 确认取消 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('66') }}</el-button>
      <el-button type="primary" plain @click="handleInviteApproval">{{ $t('131') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
// 部门列表
import depTree from '@/components/dep-tree'
// 部门列表
import jobSelect from '@/components/jobSelect'
import UpdateProbationRadio from '@/components/probation-status-radio.vue'
// 同意接口
import { inviteApproval } from 'api/settings'
import { getRegularEnv } from 'api/dashboard'
import { sysInfoFn, getCallTypeUrlMethod } from 'api/org/per'

import { v4 as uuidv4 } from 'uuid'

export default {
  components: {
    depTree,
    jobSelect
  },
  data() {
    const slef = this
    /**
     *  1. 结算类型列表
     *  2. 发薪方式列表
     */
    return {
      salaryList: [],
      settlemenList: [],
      callTypeList: [],
      visible: false,
      dataForm: {
        department_name: '',
        department_id: '',
        job_title_id: '',
        hire_date: '',
        formal_date: '',
        salary_method: '',
        settlement_type: '',
        probation_day: ''
      },
      cDataForm: {},
      dataRule: {
        first_name: [
          { required: true, message: this.$t('323'), trigger: 'blur' },
          {
            min: 1,
            max: 30,
            message: this.$t('invite_6'),
            trigger: 'blur'
          }
        ],
        call_type: [{ required: true, message: this.$t('221'), trigger: 'change' }],
        last_name: [
          { required: true, message: this.$t('1049'), trigger: 'blur' },
          {
            min: 1,
            max: 35,
            message: this.$t('invite_5'),
            trigger: 'blur'
          }
        ],
        department_name: [
          {
            required: true,
            message: this.$t('877')
          }
        ],
        hire_date: [{ required: true, message: this.$t('790'), trigger: 'change' }],
        salary_method: [{ required: true, message: this.$t('827'), trigger: 'change' }],
        settlement_type: [{ required: true, message: this.$t('827'), trigger: 'change' }]
      },
      pickerOptions: {
        disabledDate: time => {
          // 离职日期、转正日期、停职日期在hire_date之后可以选择
          const hire_date = new Date(slef.dataForm.hire_date).getTime() - 86400000
          return time.getTime() < hire_date
        }
      },
      popover: false
    }
  },
  methods: {
    init(item) {
      item.formal_state = !item.formal_state || item.formal_state === '0' ? '1' : item.formal_state
      this.visible = true
      this.dataForm = {
        ...this.dataForm,
        ...item,
        department_name: '',
        department_id: '',
        job_title_id: ''
      }
      // 获取称谓列表
      getCallTypeUrlMethod().then(res => (this.callTypeList = res && res.data))
      this.sysInfoFn()
      // 获取试用期天数
      getRegularEnv({ code: 'STAFF_PROBATION_DAY' }).then(res => {
        if (res && res.code && !this.dataForm.probation_day) this.dataForm.probation_day = res.data
      })
      this.cDataForm = JSON.parse(JSON.stringify(this.dataForm))
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
      })
    },
    // 获取选项
    async sysInfoFn() {
      const res = await sysInfoFn()
      if (res && res.code === 1) {
        this.salaryList = res.data.salary_method
        this.settlemenList = res.data.settlement_type
      }
    },
    // 出生日期禁选项 必须大于当前日期
    disabledDate(t) {
      return new Date().getTime() < t.getTime()
    },
    onProbationDay(v) {
      this.handleProbation(v, this.dataForm.hire_date)
    },
    onHireDate(v) {
      this.handleProbation(this.dataForm.probation_day, v)
    },
    handleProbation(v, hire) {
      // 填写了“试用期(天)”，自动计算：转正日期=入职日期+试用期(天)——入职日期为第0天
      if (!String(v)) return
      const day = Number(v)
      const hireData = new Date(hire)
      hireData.setDate(hireData.getDate() + day)
      this.dataForm.formal_date = this.formatDay(hireData)
    },
    // 时间戳转换为日期 2020-09-08
    formatDay(timestamp) {
      var date = new Date(timestamp)
      var YY = date.getFullYear()
      var MM = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      var DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      return `${YY}-${MM}-${DD}`
    },
    handlerChangeCallType(params) {
      // 称谓同步
      this.dataForm.call_type_en = params
    },
    changeDormal(v) {
      // 修改转正日期
      const newTime = new Date().getTime()
      const selectTime = new Date(v).getTime()
      if (selectTime < newTime && this.dataForm.formal_date) {
        const h = this.$createElement
        let formal_state
        this.$msgbox({
          title: this.$t('229'),
          message: h(UpdateProbationRadio, {
            // see https://github.com/ElemeFE/element/issues/8931
            key: uuidv4(),
            on: {
              change(v) {
                formal_state = v
              }
            }
          }),
          distinguishCancelAndClose: true,
          showCancelButton: true,
          confirmButtonText: this.$t('131'),
          cancelButtonText: this.$t('66'),
          customClass: 'probation-msg-box'
        })
          .then(() => {
            this.dataForm.formal_state = formal_state
            if (formal_state === '1') {
              this.dataForm.formal_date = this.cDataForm.formal_date || this.dataForm.formal_date
            }
            inviteApproval({ ...this.dataForm, state: 1 }).then(res => {
              this.dataForm = {}
              this.visible = false
              this.$refs.dataForm.resetFields()
              this.$emit('handleGetPendingList')
            })
          })
          .catch(action => {
            // if (action === 'close') return
            // this.dataForm.formal_date = this.cDataForm.formal_date || this.dataForm.formal_date
            // this.dataForm.formal_state = '1'
            // inviteApproval({ ...this.dataForm, state: 1 }).then(res => {
            //   this.dataForm = {}
            //   this.visible = false
            //   this.$refs.dataForm.resetFields()
            //   this.$emit('handleGetPendingList')
            // })
          })
      } else {
        inviteApproval({ ...this.dataForm, state: 1 }).then(res => {
          this.visible = false
          this.$refs.dataForm.resetFields()
          this.$emit('handleGetPendingList')
        })
      }
    },
    handleNodeClick(val) {
      this.dataForm.department_name = val.department_name
      this.dataForm.department_id = val.department_id
      this.popover = false
    },
    handleInviteApproval() {
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          this.changeDormal(this.dataForm.formal_date)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.input-with-select {
  /deep/ {
    .el-input-group__prepend {
      background: #fff;
      .el-select {
        width: 150px;
      }
      .el-input {
        max-width: 100%;
      }
    }
  }
}
.name1 {
  .call_type {
    width: 150px;
    float: left;
    .el-select {
      width: 150px;
      /deep/ .el-input {
        max-width: 100%;
      }
    }
  }
  .first_name {
    width: 209px;
    float: left;
    .el-input {
      max-width: 100%;
      width: 100%;
    }
  }
}
.name {
  /deep/ &.is-error {
    .el-input__inner {
      border-color: #dcdfe6;
    }
    .first_name {
      .el-input__inner {
        border-color: #f56c6c;
      }
      .el-input-group__prepend {
        border-color: #dcdfe6;
        .el-input__inner {
          border: none;
        }
      }
    }
    .call_type {
      .el-input-group__prepend {
        border-color: #f56c6c;
        .el-input__inner {
          border: none;
        }
      }
      .el-input__inner {
        border-left: 1px solid #f56c6c;
      }
    }
  }
}
/deep/ .el-input {
  width: 360px;
  max-width: 360px;
  height: 32px;
  input {
    height: 32px;
  }
}
/deep/ .el-dialog__body {
  min-height: 200px;
}
</style>
